export enum ContainerLocationStatus {
  Unknown = 0,
  InStock = 1,
  CheckedOut = 2,
  Overdue = 3,
  OverdueSold = 4,
  Completed = 5,
  OverdueError = 6,
  OverdueNoCharge = 7,
  Lost = 8,
  Recovered = 9,
  OnHold = 10,
  LostByStore = 11,
  Broken = 12,
  BrokenAtUser = 13,
  InTransit = 14,
}
